<template>
  <div class="pvDetail" style="width:50%;">
    <el-dialog :title="dialogTitle" custom-class="pvDetailBox" :visible.sync="isShowDetail" :fullscreen="fullscreen" :close-on-click-modal ="false"  align="left" width="80%" @close="close">
      <el-button align="right" v-on:click="changeParameters()" type="primary">Change archival parameters</el-button>
      <el-button align="right" v-on:click="pauseArchiving()" type="primary">Pause archiving</el-button>
      <el-button align="right" v-on:click="ResumeArchiving()" type="primary">Resume archiving</el-button>
      <el-button align="right" :disabled ="disabled" v-on:click="deletePV()" type="primary">Delete PV</el-button>
      <el-table v-loading="pieLoading" :data= "tableData" stripe>
          <el-table-column prop="name" label="Attribute"  align="left"></el-table-column>
          <el-table-column prop="value" label="Detail"  align="left"></el-table-column>
      </el-table>
    </el-dialog>
    <pvChangeParm v-if="isShowParm" :pvDetailInfo ="pvDetailInfo" @close="closeParm" @refreshDetail = "query"></pvChangeParm>
  </div>
</template>

<script>
import pvChangeParm from './pvChangeParm'
    export default {
        name: "pvDetail",
        components:{pvChangeParm},
        props:{
          pvDetailInfo:{
            type:Object,
            default:{}
          }
        },
        computed:{
          dialogTitle:{
            get:function() {
              return 'Here are the complete details of the PV  ' + '' + this.pvDetailInfo.pvName +'.'
            }
          }
        },
        data(){
          return {
            fullscreen:false,
            isShowDetail:true,
            pieLoading:false,
            isShowParm:false,
            tableData:[],
            disabled:null,
          }
        },
      mounted(){
        this.query();
      },
      methods:{
        query:function(){
          this.$axios({ 
            method:'get',
            url:'/hdars/hdars/mgmt/getPVDetails?pv=' + this.pvDetailInfo.pvName
          }).then((response) => {
            this.tableData = response.data;
            if(this.tableData && this.tableData[9] && this.tableData[9].value === 'No'){
            
              this.disabled = true;
            }else{
              this.disabled = false;
            }
          })
        },
        close:function(){
          this.$emit('close');
        },
        closeParm(){
          this.isShowParm = false;
        },
        //改变archival parameters
        changeParameters(){
          this.isShowParm = true;
        },
        //暂停archival
        pauseArchiving(){
          this.$axios({ 
            method:'get',
            url:'/hdars/hdars/mgmt/pauseArchivingPV?pv=' + this.pvDetailInfo.pvName
          }).then((data) => {
              this.$message('Operation successful');
              this.query();
            }).catch( ()=>{this.$message('Operation failed');})
        },
        //开启archival
        ResumeArchiving(){
          this.$axios({ 
            method:'get',
            url:'/hdars/hdars/mgmt/resumeArchivingPV?pv=' + this.pvDetailInfo.pvName
          }).then((data) => {
              this.$message('Operation successful');
              this.query();
            }).catch( ()=>{this.$message('Operation failed');})
        },
        //删除pv
        deletePV(){
          this.$confirm('Are you certain you want to stop archiving ' + this.pvDetailInfo.pvName + '?','Notice',{
            confirmButtonText:'Sure',
            cancelButtonText:'cancle',
            type:'warning',
            center:true,
          }).then(()=>{
            this.$axios({ 
              method:'get',
              url:'/hdars/hdars/mgmt/deletePV?pv=' + this.pvDetailInfo.pvName + '&deleteData=true'
            }).then(() => {
              this.$message('Operation successful');
              this.close();
              this.$emit('refreshTable');
            }).catch( ()=>{this.$message('Operation failed');})
          })
        }
      }
    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/activePublic/pvManagement/pvDetail.vue